import SwitchBoxWithItems from 'components/switchbox/switchBoxWithItems';
import { useState } from 'react';
import SellEstimate from './sellEstimate';
import BuyEstimate from './buyEstimate';
import { IMortgageInfo } from 'screens/estimate/interfaces';

import style from './styles.module.scss';
import clsx from 'clsx';

interface IPossibilitiesEstimateProps {
  averageMarketPrice: string;
  mortgageInfo: IMortgageInfo;
  isSecondary: boolean;
  isHideBorder: boolean;
  isMarginMore: boolean;
}

const PossibilitiesEstimate = ({
  averageMarketPrice,
  mortgageInfo,
  isSecondary,
  isHideBorder,
  isMarginMore,
}: IPossibilitiesEstimateProps) => {
  const [isSellScreen, setIsByScreen] = useState(true);

  const handleSwitchByScreen = (value: boolean) => {
    setIsByScreen(value);
  };

  return (
    <div className={style.possibilities}>
      <div
        className={clsx(
          style.possibilities__container,
          isMarginMore && style.possibilities__container_marginMore,
        )}
      >
        <div className={style.possibilities__switcher}>
          <SwitchBoxWithItems
            onChangeSwitcher={handleSwitchByScreen}
            isChecked={isSellScreen}
            classNameSwitcher='slider_estimate'
          />
        </div>

        <div
          className={clsx(
            style.possibilities__card,
            isHideBorder && style.possibilities__withoutCard,
          )}
        >
          <div className={style.possibilities__title}>
            <h4>{isSellScreen ? 'Продать:' : 'Купить:'}</h4>
          </div>

          {!isSellScreen ? (
            <div className={style.possibilities__by}>
              <BuyEstimate
                averageMarketPrice={averageMarketPrice}
                mortgageInfo={mortgageInfo}
                isSecondary={isSecondary}
              />
            </div>
          ) : (
            <div className={style.possibilities__sell}>
              <SellEstimate isSecondary={isSecondary} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PossibilitiesEstimate;
